import { INITIAL_GPT_QUOTA } from '../constants/gpt';

/**
 * The AI generation quota — a single number in localStorage, read and written
 * by every AI drawer.
 *
 * Split out of `utils/openai` and re-exported from it, so every existing
 * `import { getGPTQuota } from './openai'` keeps working. The split exists
 * because that module's OTHER half — `handleError`, `goToGPTOptions` — needs
 * the app store, the router and the global intl, which makes importing it a
 * decision about the whole application. Reading a number out of localStorage
 * should not be.
 *
 * Concretely: `QuotaTypography` is now rendered by the shared drawer shell, so
 * without this split every test that mounts any AI drawer would build the real
 * redux store to display "配額: 18 / 50".
 *
 * Nothing here throws on a browser with storage disabled; the whole point of
 * the try/catch is that a private-mode adviser sees a full quota rather than a
 * crashed drawer.
 */
export const getGPTQuota = () => {
  try {
    const gptQuotaString = localStorage.getItem('gptQuota');
    const gptQuota = parseInt(gptQuotaString);
    if (isNaN(gptQuota)) {
      return INITIAL_GPT_QUOTA;
    } else if (process.env.NODE_ENV === 'development') {
      return 1;
    }
    return gptQuota;
  } catch (error) {
    return INITIAL_GPT_QUOTA;
  }
};

export const validateGPTQuota = () => {
  if (getGPTQuota() <= 0) {
    throw new Error('Quota exceeded');
  }
};

export const resetGPTQuota = () => localStorage.setItem('gptQuota', INITIAL_GPT_QUOTA.toString());

export const decreaseGPTQuota = () => {
  const quota = getGPTQuota();
  localStorage.setItem('gptQuota', (quota ? quota - 1 : 0).toString());
};
